import pubSub from 'app/common/lib/PubSub';
import sendActiveUserPing from 'app/common/lib/react/sendActiveUserPing';

const focusUtil = {};

/**
 * Store the visibility state of the window (in focus or user has tabbed away)
 */
focusUtil.windowIsInFocus = true;

/**
 * When app starts, listen to window `focus`, `blur`, and `scroll` events, and publish when those events occur
 */
focusUtil.initFocus = function() {
  const _onWindowBlur = function() {
    pubSub.instance.publish(PCONST.PUBSUB_CHANNEL_SITE, PCONST.PUBSUB_TOPIC_WINDOW_VISIBILITY_BLUR);
  };

  const _onWindowFocus = function() {
    pubSub.instance.publish(
      PCONST.PUBSUB_CHANNEL_SITE,
      PCONST.PUBSUB_TOPIC_WINDOW_VISIBILITY_FOCUS,
    );
    // Active User Ping -- DO NOT REMOVE
    sendActiveUserPing();
  };

  pubSub.instance.subscribe(
    PCONST.PUBSUB_CHANNEL_SITE,
    PCONST.PUBSUB_TOPIC_WINDOW_VISIBILITY_FOCUS,
    () => {
      focusUtil.windowIsInFocus = true;
    },
  );

  pubSub.instance.subscribe(
    PCONST.PUBSUB_CHANNEL_SITE,
    PCONST.PUBSUB_TOPIC_WINDOW_VISIBILITY_BLUR,
    () => {
      focusUtil.windowIsInFocus = false;
    },
  );

  window.addEventListener(PCONST.EVENT_FOCUS, _onWindowFocus);
  window.addEventListener(PCONST.EVENT_BLUR, _onWindowBlur);
};

export default focusUtil;
